// Subscription status as the billing page (/coach/billing) and the profile
// hub's Subscription section both read it from GET /entitlement/.

export const STATUS_META = {
  active: { label: 'Active', tone: 'outline', dot: '#1f9d55' },
  trialing: { label: 'Trial', tone: 'soft', dot: '#2f6fed' },
  canceling: { label: 'Cancels at period end', tone: 'attention' },
  canceled: { label: 'Canceled', tone: 'critical' },
  cancelled: { label: 'Canceled', tone: 'critical' },
  expired: { label: 'Expired', tone: 'critical' },
  past_due: { label: 'Past due', tone: 'critical' },
  unpaid: { label: 'Unpaid', tone: 'critical' },
  incomplete: { label: 'Incomplete', tone: 'attention' },
};

const ENDED = ['canceled', 'cancelled', 'expired', 'past_due', 'unpaid'];
const FREE_TIERS = ['coach_free', 'public'];

// Whether a paid plan is live and how its status reads.
export const planState = (entitlement = {}) => {
  const status = entitlement.subscriptionStatus || null;
  const isPendingCancellation = status === 'canceling' || !!entitlement.cancelAtPeriodEnd;
  const isEnded = ENDED.includes(status);
  const isActiveSubscription = (status === 'active' || status === 'trialing') && !isPendingCancellation;
  const tier = (entitlement.subscriptionTier || '').toLowerCase();
  const onPaidTier = !!tier && !FREE_TIERS.includes(tier);
  const hasPlan = onPaidTier && (isActiveSubscription || isPendingCancellation);
  const statusMeta = isPendingCancellation ? STATUS_META.canceling : STATUS_META[status] || null;
  return { status, isPendingCancellation, isEnded, isActiveSubscription, hasPlan, statusMeta };
};
